module.exports = __webpack_public_path__ + "static/media/anobis-landscape-background.ac328974.svg";